

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
// import DistributorsFormData from "../components/ProducerForm/DistributorsFormData"
// import FilmFestivalFormData from '../components/FilmFestivalSubmission/FilmFestivalFormPendingData';
import FilmFestivalDetails from "./FilmFestivalFormDetailsModule"
// import FilmFestivalFormPendingData from '../components/FilmFestivalSubmission/FilmFestivalFormPendingData';
// import FilmFestivalFormShortListData from '../components/FilmFestivalSubmission/FilmFestivalFormShortListData';
import FilmFestivalFormRejectedData from '../components/FilmFestivalSubmission/FilmFestivalFormRejectedData';
// import FilmFestivalFormNominatedData from '../components/FilmFestivalSubmission/FilmFestivalFormNominatedData';



function FilmFestivalFormRejectedDataModule() {
  return (
    <div className="App">
    
<Routes>
{/* < Route path='/FilmFestivalFormPendingData' element={<Layout children={FilmFestivalFormPendingData()}/>}/> */}
{/* < Route path='/FilmFestivalFormShortListData' element={<Layout children={FilmFestivalFormShortListData()}/>}/> */}
< Route path='/FilmFestivalRejectedData' element={<Layout children={FilmFestivalFormRejectedData()}/>}/>
{/* < Route path='/FilmFestivalFormNominatedData' element={<Layout children={FilmFestivalFormNominatedData()}/>}/> */}

< Route path='/FilmFestivalRejectedData/*' element={<FilmFestivalDetails key="FilmFestivalRejectedData"/>}/>

      </Routes>
    </div>
  );
}

export default FilmFestivalFormRejectedDataModule;